export const selectAuthToken = (state) => state.auth.userData?.token;

export const selectCompanyUUID = (state) => state.auth.userData?.user?.company?.uuid;

export const selectCompanyStatus = (state) => state.auth.userData?.user?.company?.status;

export const selectCompany = (state) => state?.auth?.userData?.user?.company;

export const selectCompanyAccessCode = (state) => state?.auth?.userData?.user?.company?.uuid;

export const selectLoggedInUser = (state) => state?.auth?.userData?.user;

export const selectedLoggedInAdmin = (state) => state?.auth?.adminData;

export const selectAdminEmail = (state) => state?.auth?.adminData?.email;

export const selectIsSandboxAdminExist = (state) => state?.auth?.isSandboxAdminExist ?? false;
